import api from "../api";
import { IPaginateResponse } from "@/interfaces/Fetch";
import {
  CalendarVisibility,
  CalendarVisibilityFilters,
  CalendarVisibilityFormSend,
} from "@/interfaces/CalendarVisibility";

export const calendarVisibilitiesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCalendarVisibilities: build.query<
      IPaginateResponse<CalendarVisibility>,
      CalendarVisibilityFilters
    >({
      query: (params) => ({
        url: "/calendar-visibilities",
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: "CalendarVisibilities" as const,
                id,
              })),
              { type: "CalendarVisibilities", id: "LIST" },
            ]
          : [],
    }),
    getMyCalendarVisibilities: build.query<CalendarVisibility[], void>({
      query: () => "/calendar-visibilities/mine",
      providesTags: [{ type: "MyCalendarVisibilities", id: "ME" }],
    }),
    storeCalendarVisibility: build.mutation<
      CalendarVisibility,
      CalendarVisibilityFormSend
    >({
      query: (body) => ({
        url: "/calendar-visibilities",
        method: "POST",
        body,
      }),
      invalidatesTags: [
        { type: "CalendarVisibilities", id: "LIST" },
        { type: "MyCalendarVisibilities", id: "ME" },
      ],
    }),
    destroyCalendarVisibility: build.mutation<void, string>({
      query: (id) => ({
        url: `/calendar-visibilities/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [
        { type: "CalendarVisibilities", id: "LIST" },
        { type: "MyCalendarVisibilities", id: "ME" },
      ],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetCalendarVisibilitiesQuery,
  useLazyGetCalendarVisibilitiesQuery,
  useGetMyCalendarVisibilitiesQuery,
  useStoreCalendarVisibilityMutation,
  useDestroyCalendarVisibilityMutation,
} = calendarVisibilitiesApi;
